import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { List } from './List'

export const ClientId = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.url}`}>
        <List />
      </Route>
    </Switch>
  )
}
